import { render, staticRenderFns } from "./others-registre.html?vue&type=template&id=4d41cb2d&scoped=true&external"
import script from "./others-registre.js?vue&type=script&lang=js&external"
export * from "./others-registre.js?vue&type=script&lang=js&external"
import style0 from "./others-registre.scss?vue&type=style&index=0&id=4d41cb2d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41cb2d",
  null
  
)

export default component.exports